import axios, { AxiosError } from 'axios';
import { Credentials, User, UUID, VriAPIResponse, VriAPIResult } from '../types';
import { getErrorMessage } from '../lib/error-handling';
import END_POINT from '../config/endpoints.constants';

export interface LoginResult extends VriAPIResult {
    data?: {
        user: User;
    };
    isCaptchaRequired?: boolean;
}

export interface LoginResponse extends VriAPIResponse {
    data: User;
}

export interface LoginErrorResponse extends VriAPIResponse {
    data?: {
        isCaptchaRequired?: boolean;
    };
}

export async function login(credentials: Credentials): Promise<LoginResult> {
    const result = {} as LoginResult;
    try {
        const { data: responseData } = await axios.post<LoginResponse>(
            END_POINT.LOGIN_V1,
            credentials,
        );

        result.data = { user: responseData.data };
    } catch (error) {
        result.error = getErrorMessage(error);
        const axiosError = error as AxiosError<LoginErrorResponse>;
        result.isCaptchaRequired = axiosError?.response?.data?.data?.isCaptchaRequired ?? false;
    }
    return result;
}

export interface GetUserResult extends VriAPIResult {
    data?: {
        user: User;
    };
}

export interface GetUserResponse extends VriAPIResponse {
    data: {
        userDetails: User;
    };
}

export async function getUser(): Promise<GetUserResult> {
    const result: GetUserResult = {};
    try {
        const { data: responseData } = await axios.post<GetUserResponse>(END_POINT.CUSTOMER, {});
        if (responseData) {
            result.data = { user: responseData.data.userDetails };
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}

export interface LogoutOptions {
    deviceId: UUID;
}
export interface LogoutResult extends VriAPIResult {
    data?: {
        message: string;
    };
}
export interface LogoutResponse extends VriAPIResponse {
    data: null;
}

export async function logout(options: LogoutOptions): Promise<LogoutResult> {
    const result: LogoutResult = {};
    try {
        const { data: responseData } = await axios.post<LogoutResponse>(END_POINT.LOGOUT, options);
        if (responseData) {
            result.data = { message: responseData.message };
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
